import { useBuildUpdateCheck } from "../../hooks/useBuildUpdateCheck";
import { useEmployeeProfile } from "../../hooks/useEmployeeProfile";
import AlertModal from "../../CommonElements/AlertModal";

const hardReload = () => window.location.reload();

const BuildUpdateAlert = () => {
  const { hasUpdate } = useBuildUpdateCheck(60000);

  const { loggedInEmployee } = useEmployeeProfile();

  if (!hasUpdate) return null;

  const title =
    `Hey ${loggedInEmployee?.name}!` + "\n" + "New Update Available";

  const message = [
    "A newer version of this app has been deployed.",
    "",
    // `Current: ${localInfo.version}@${localInfo.commit} (${new Date(
    //   localInfo.buildTime
    // ).toLocaleString()})`,
    // `Latest:  ${serverInfo?.version}@${serverInfo?.commit} (${
    //   serverInfo ? new Date(serverInfo.buildTime).toLocaleString() : "—"
    // })`,
    "",
    "Click OK to refresh now.",
  ].join("\n");

  return (
    <AlertModal
      show
      type="success"
      title={
        <>
          Hey {loggedInEmployee?.name}!<br />
          New Update Available
        </>
      }
      message={message}
      onConfirm={hardReload}
    />
  );
};

export default BuildUpdateAlert;
